import { API2_HOST } from 'helpers/urlHelper';
import {
  baseGetWithoutParam,
  baseSearch
} from 'services/base-services/baseService';
import { objectToQueryString } from 'helpers/utils';
import axios from 'services/api';

export const getSuppliers = async () => {
  return await baseGetWithoutParam(`${API2_HOST}/sls-wpo-dashboard/suppliers`);
};

export const getGrns = async (wpoNo) => {
  return await baseGetWithoutParam(`${API2_HOST}/sls-wpo-dashboard/${wpoNo}/grns`);
};

export const searchs = async request => {
  const res = await baseSearch(
    `${API2_HOST}/sls-wpo-dashboard/overview`,
    request
  );
  return res;
};

export const exportExcel = async request => {
  const res = await axios({
    method: 'get',
    url: `${API2_HOST}/sls-wpo-dashboard/export?${objectToQueryString(request)}`,
    responseType: 'blob'
  });

  return res;
};